import {combineReducers} from 'redux'

const identity = <TState = {}>(state: TState) => state || null

export const rootReducer = combineReducers({
  config: identity,
  i18n: identity,
})
